const ANGULAR_RUNTIME_STATE_PREFIXES = [
    "kb.configurator",
    "kb.configuredProduct",
    "kb.configuratorTest",
    "scene",
    "kb.login",
] as const;

const ANGULAR_ADMIN_CONFIGURATOR_STATES = new Set([
    "kb.admin.base.configuratorEdit",
    "kb.admin.base.configuratorNew",
]);

export interface HostedRouteOwnershipInput {
    currentVuePath: string | undefined;
    hostMode: string | undefined;
    targetHref: string | undefined;
    targetStateName: string | undefined;
}

/**
 * Returns true only when a transition can stay inside the currently mounted Angular host.
 * Vue owns navigation between admin resources and chooses whether a configurator destination is V2 or V3.
 */
export function shouldAngularOwnHostedTransition(input: HostedRouteOwnershipInput): boolean {
    const stateName = input.targetStateName;
    if (!stateName) return false;

    if (ANGULAR_RUNTIME_STATE_PREFIXES.some(prefix =>
        stateName === prefix || stateName.startsWith(`${prefix}.`)
    )) {
        return true;
    }

    if (input.hostMode !== "admin") return false;
    if (stateName === "kb.admin.**") return true;
    if (!ANGULAR_ADMIN_CONFIGURATOR_STATES.has(stateName)) return false;

    const currentConfigurator = readAdminConfiguratorIdentity(input.currentVuePath);
    const targetConfigurator = readAdminConfiguratorIdentity(input.targetHref);
    return currentConfigurator !== null && currentConfigurator === targetConfigurator;
}

function readAdminConfiguratorIdentity(url: string | undefined): string | null {
    if (!url) return null;

    let pathname: string;
    try {
        pathname = new URL(url, "https://kbmax.local").pathname;
    } catch {
        return null;
    }

    if (pathname === "/admin/configurators/new") return "new";

    const match = pathname.match(/^\/admin\/configurators\/(\d+)(?:\/.*)?$/);
    return match ? `id:${match[1]}` : null;
}
